import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "./useAppStore";
import {
  fetchErrors,
  fetchErrorsSummary,
  setEventsPage,
  setSelectedAllianceId,
} from "../store/slices/errorsSlice";
import { PAGE_SIZE_ERRORS_SUMMARY } from "../constants";
import { sliceForPage } from "../components/ClientSidePagination";

export function useErrorsPage() {
  const dispatch = useAppDispatch();
  const [summaryPage, setSummaryPage] = useState(1);
  const {
    summary,
    events,
    eventsTotal,
    eventsPage,
    eventsLimit,
    eventsTotalPages,
    selectedAllianceId,
    summaryLoading,
    eventsLoading,
    error,
  } = useAppSelector((state) => state.errors);

  const summaryTotalPages = Math.max(
    1,
    Math.ceil(summary.length / PAGE_SIZE_ERRORS_SUMMARY),
  );
  const paginatedSummary = useMemo(
    () => sliceForPage(summary, summaryPage, PAGE_SIZE_ERRORS_SUMMARY),
    [summary, summaryPage],
  );

  useEffect(() => {
    dispatch(fetchErrorsSummary());
  }, [dispatch]);

  useEffect(() => {
    setSummaryPage(1);
  }, [summary.length]);

  useEffect(() => {
    if (summaryPage > summaryTotalPages) {
      setSummaryPage(summaryTotalPages);
    }
  }, [summaryPage, summaryTotalPages]);

  useEffect(() => {
    if (selectedAllianceId) {
      dispatch(
        fetchErrors({
          allianceId: selectedAllianceId,
          page: eventsPage,
          limit: eventsLimit,
        }),
      );
    }
  }, [dispatch, selectedAllianceId, eventsPage, eventsLimit]);

  const selectAlliance = (allianceId: string | null) => {
    dispatch(setSelectedAllianceId(allianceId));
  };

  const changeEventsPage = (page: number) => {
    if (!selectedAllianceId) return;
    dispatch(setEventsPage(page));
  };

  const changeSummaryPage = (page: number) => {
    setSummaryPage(page);
  };

  return {
    summary,
    paginatedSummary,
    summaryPage,
    summaryTotalPages,
    summaryPageSize: PAGE_SIZE_ERRORS_SUMMARY,
    events,
    eventsTotal,
    eventsPage,
    eventsLimit,
    eventsTotalPages,
    selectedAllianceId,
    summaryLoading,
    eventsLoading,
    error,
    selectAlliance,
    changeEventsPage,
    changeSummaryPage,
  };
}
